module.exports = __webpack_public_path__ + "static/media/total-power.a46f01c3.png";